import React, { useCallback, useEffect, useState } from 'react';
import { LanguageContext, type Language } from './LanguageContext.shared';
import { resolveTranslation, getSavedLanguage, saveLanguage, onLanguageChange } from '../i18n';

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguageState] = useState<Language>(getSavedLanguage);

  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    saveLanguage(lang);
  };

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  useEffect(() => {
    return onLanguageChange((newLang) => {
      setLanguageState(newLang);
    });
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.location?.search) {
      const urlParams = new URLSearchParams(window.location.search);
      const urlLang = urlParams.get('lang');
      if (urlLang && (urlLang === 'ro' || urlLang === 'en' || urlLang === 'fr') && urlLang !== language) {
        setLanguageState(urlLang);
        saveLanguage(urlLang);
      }
    }
  }, [language]);

  const t = useCallback((keyPath: string, variables?: Record<string, unknown>): string => {
    return resolveTranslation(language, keyPath, variables);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
